import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=47ff47d8&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=47ff47d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff47d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ff47d8')) {
      api.createRecord('47ff47d8', component.options)
    } else {
      api.reload('47ff47d8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=47ff47d8&scoped=true", function () {
      api.rerender('47ff47d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataModel/edit.vue"
export default component.exports